module.exports = __webpack_public_path__ + "static/media/Christmas_3.dd497690.jpg";